import { generateClient, GraphQLResult } from "aws-amplify/api";
// @ts-ignore
import { getFieldTemplate } from "../graphql/queries";
import { recordSentry } from "./recordSentry";
import { FieldTemplate, Option } from "db/definitions";

async function getOptions(fieldTemplate: FieldTemplate, nextToken: string | null = null): Promise<Option[]> {
	const options = await getBatch(fieldTemplate.id, nextToken, []);
	return options;
}

async function getBatch(id: string, nextToken: string | null, prevItems: Option[]) {
	try {
		const client = generateClient({ authMode: "userPool" });
		interface QueryResponse {
			getFieldTemplate: FieldTemplate;
		}
		const optionData = (await client.graphql({
			query: getFieldTemplate,
			variables: { id: id, nextToken: nextToken },

			authMode: "userPool",
		})) as GraphQLResult<QueryResponse>;
		const fieldTemplate = optionData.data.getFieldTemplate;

		if (fieldTemplate.options?.nextToken) {
			prevItems = prevItems.concat(fieldTemplate.options.items);

			return getBatch(id, fieldTemplate.options.nextToken, prevItems);
		} else {
			prevItems = prevItems.concat(fieldTemplate.options?.items || []);

			return prevItems;
		}
	} catch (error) {
		recordSentry({ error, msg: "Error getting all the options: " });
	}
	return prevItems;
}

export default getOptions;
